import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  const isPublicAuthRoute =
    config.url === '/auth/register/' || config.url === '/auth/login/';

  if (token && !isPublicAuthRoute) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

// Auth APIs
export const authAPI = {
  register: (data) => api.post('/auth/register/', data),
  login: (data) => api.post('/auth/login/', data),
  logout: () => api.post('/auth/logout/'),
  getProfile: () => api.get('/auth/profile/'),
  changePassword: (data) => api.post('/auth/change-password/', data),
};

// Dashboard APIs
export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats/'),
  getUsage: (days = 30) => api.get(`/dashboard/usage/?days=${days}`),
};

// Chatbot APIs
export const chatbotAPI = {
  list: () => api.get('/chatbots/'),
  create: (data) => api.post('/chatbots/', data),
  get: (id) => api.get(`/chatbots/${id}/`),
  update: (id, data) => api.put(`/chatbots/${id}/`, data),
  delete: (id) => api.delete(`/chatbots/${id}/`),
};

// Document APIs
export const documentAPI = {
  list: () => api.get('/documents/'),
  upload: (formData) => {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return api.post('/documents/upload/', formData, config);
  },
  delete: (documentId) => api.delete('/documents/', { data: { document_id: documentId } }),
};

// Conversation APIs
export const conversationAPI = {
  list: () => api.get('/conversations/'),
  get: (id) => api.get(`/conversations/${id}/`),
};

// Business APIs
export const businessAPI = {
  create: (data) => api.post('/businesses/', data),
  rotateKey: () => api.post('/businesses/rotate-key/'),
  getWidgetSnippet: () => api.get('/widget/snippet/'),
};

export default api;
